import clsx from 'clsx'
import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { useMutation } from 'react-query'
import { Outlet, useLocation, useParams, useMatch } from 'react-router-dom'
import BreadCrumbs from '../components/BreadCrumbs'
import UserDrawer from '../components/Customers/UserDrawer'
import NewLocationBtn from '../components/NewLocationBtn'
import PageNav from '../components/PageNav'
import Spinner from '../components/Spinner'
import { useCustomer } from '../hooks/useCustomer'
import { useUser } from '../hooks/useUser'
import placeService from '../services/placeService'
import { CustomerUser } from '../types/customer-user'
import { queryClient } from '../utils/react-query'
import { BuzzlUsersError } from '../types/buzzl-user'

const Customer = () => {
  const { customerId } = useParams<{ customerId: string }>()
  const { pathname } = useLocation()
  const { data, isLoading } = useCustomer()
  const user = useUser()
  const [itemDrawerStatus, setItemDrawerStatus] = useState(false)
  const [selectedUser, setSelectedUser] = useState<any>()

  const breadCrumbPages = [
    { name: 'Customers', href: '/customers' },
    { name: customerId ? 'Update Customer' : 'New Customer', href: pathname },
  ]

  const navigation = [
    { name: 'Details', href: `/customers/${customerId}` },
    { name: 'Locations', href: `locations` },
    { name: 'Experiences', href: `experiences` },
    { name: 'Users', href: `users` },
  ]

  const isCustomerPath = useMatch('/customers/:customerId/users')
  const isLocationsPath = useMatch('/customers/:customerId/locations')

  const handleOpenUserDrawer = (user: CustomerUser) => {
    setItemDrawerStatus(true)
    setSelectedUser(user)
  }

  const requestClaimPlace = useMutation(placeService.claimPlaceByGoogleId, {
    onSuccess: async () => {
      queryClient.refetchQueries('customerLocations')
      // toast.success('Location Submitted.')
    },
    // onError: (e) => {
    //   const error = e as BuzzlUsersError
    //   error.response.errors.map((er) =>
    //     toast.error(er.message || 'Something went wrong, if the error persist please contact support.')
    //   )
    // },
  })

  return (
    <div>
      <UserDrawer
        open={itemDrawerStatus}
        onClose={() => {
          setItemDrawerStatus(false)
          setSelectedUser(null)
        }}
        selectedUser={selectedUser}
      />
      <BreadCrumbs breadCrumbPages={breadCrumbPages} />
      {data && <h1 className="page-title">{data.name}</h1>}

      {customerId && (
        <div
          className={clsx({
            'flex items-start justify-between': isCustomerPath || isLocationsPath,
          })}
        >
          <div
            className={clsx({
              'flex-1 md:mr-5': isCustomerPath || isLocationsPath,
            })}
          >
            <PageNav navigation={navigation} />
          </div>
          {!isLoading && isCustomerPath && (
            <button className="btn btn-primary" onClick={() => setItemDrawerStatus(true)}>
              Add User
            </button>
          )}
          {!isLoading && isLocationsPath && user.data?.role !== 'OPERATOR' && user.data?.role !== 'MANAGER' && (
            <NewLocationBtn
              type="button"
              className="btn btn-primary"
              nbRemainingLicenses={data?.nbRemainingLicenses || 0}
              claimFn={async (place) => {
                await toast.promise(
                  requestClaimPlace.mutateAsync({ googlePlaceId: place.googlePlaceId, customerId: customerId }),
                  {
                    loading: 'Claiming...',
                    success: 'Location Submitted.',
                    // @ts-ignore
                    error: (e) => {
                      const error = e as BuzzlUsersError
                      error.response.errors.map((er) =>
                        toast.error(er.message || 'Something went wrong, if the error persist please contact support.')
                      )
                    },
                  }
                )
              }}
            >
              Claim new Location
            </NewLocationBtn>
          )}
        </div>
      )}

      {isLoading ? (
        <div className="flex h-32 items-center justify-center">
          <Spinner className="h-10 w-10" />
        </div>
      ) : (
        <Outlet context={{ data, handleOpenUserDrawer }} />
      )}
    </div>
  )
}

export default Customer
